<div class="frame-in">
  <div class="items" [ngStyle]="itemsStyle" [ngClass]="{'hidden': loading}">
    <div class="country iran"></div>
    <div class="country uae"></div>
    <div class="country saudi"></div>

    <div class="poi" (mouseenter)="mouseEnter(0)" (mouseleave)="mouseLeave(0)" style="bottom: 325px; right: 483px;"
      [ngClass]="{'hover': zones[0].hover, 'lock': zones[0].locked, 'active': zones[0].active}"
      (click)="poiClick(1)">@if (!zones[0].locked) {
      <span>9</span>
    }</div>
    <div class="country china zone3" [ngClass]="{'hover': zones[0].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(1)" (mouseleave)="mouseLeave(1)" style="bottom: 204px; right: 574px;"
      [ngClass]="{'hover': zones[1].hover, 'lock': zones[1].locked, 'active': zones[1].active}"
      (click)="poiClick(2)">@if (!zones[1].locked) {
      <span>10</span>
    }</div>
    <div class="country india" [ngClass]="{'hover': zones[1].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(2)" (mouseleave)="mouseLeave(2)" style="bottom: 180px; right: 723px;"
      [ngClass]="{'hover': zones[2].hover, 'lock': zones[2].locked, 'active': zones[2].active}"
      (click)="poiClick(3)">@if (!zones[2].locked) {
      <span>11</span>
    }</div>
    <div class="country pakistan" [ngClass]="{'hover': zones[2].hover}"></div>

    <div class="poi" (mouseenter)="mouseEnter(3)" (mouseleave)="mouseLeave(3)" style="bottom: 396px; left: 108px;"
      [ngClass]="{'hover': zones[3].hover, 'lock': zones[3].locked, 'active': zones[3].active && quizLevel !== 3}"
      (click)="poiClick(4)">@if (!zones[3].locked) {
      <span>12</span>
    }</div>
    <div class="country uzbekistan" [ngClass]="{'hover': zones[3].hover}"></div>

    <div class="poi dark" style="bottom: 52px; left: 651px;"><span>5</span></div>
    <div class="poi dark" style="bottom: 60px; right: -19px;"><span>6</span></div>
    <div class="poi dark" style="bottom: 282px; left: 819px;"><span>8</span></div>

    @if (quizLevel < 3) {
      <div class="quiz-activity zone-3-2"></div>
    }
    @if (quizLevel >= 3) {
      <div class="quiz-activity zone-3-2 active" [ngClass]="{'current': quizLevel === 3 && tick2Quiz}" [routerLink]="['/game/quiz-activity/1-3']"></div>
    }

    <div class="quiz-activity block zone-3-1"></div>

    <svg class="road zone3">
      <g>
        <path d="M899.5,138.5c-13.69-12.94-26.1-23.25-36-31-11.87-9.29-24.59-19.17-43-30a302.7,302.7,0,0,0-79-33,354.29,354.29,0,0,0-70-11c-43.76-2.55-75.74,3.38-84,5-34.67,6.81-48.16,15.71-54,20-7.12,5.23-20.13,15-27,32-3.87,9.57-1,9.63-6,30-5.22,21.39-8.45,21.68-11,38-1.59,10.17-1,14.45-4,25-2.51,8.88-4.35,15.08-10,20-6.33,5.51-13.89,6.33-20,7-5.65.62-7.72-.07-25-2-8.5-.95-14-1.56-20-2-16.48-1.2-24.71-1.8-29,0-10.86,4.55-15.82,17-23,35-5.7,14.3-6.1,21.9-14,28-4.26,3.29-6.07,2.33-17,6-20.92,7-21.72,12.59-31,13-13.31.59-27.16-10.18-33-22-4.43-9-1.39-12.76-3-38a252.83,252.83,0,0,0-4-33c-3.6-18.6-9.11-33.73-14-47-5.95-16.15-6.35-14.27-8-21-1.48-6.06-5.94-25.31,1-47,4.75-14.83,9.62-14.56,13-30,1.87-8.56,4.16-19.78-2-30a30.6,30.6,0,0,0-14-12c-6.06-2.56-12-2.64-27,0-15.49,2.73-20.37,4.79-31,7-17.39,3.62-16.89.72-38,4-27.55,4.27-37.42,10.6-42,14-4.94,3.67-10.75,8.1-13,16a27.62,27.62,0,0,0,5,24c5.16,6.47,9.1,4.65,27,15,9.82,5.68,9.5,6.73,14,8,10.54,3,14.77-2.1,26-1,7.11.69,20.28,4.18,24,13,2.37,5.61-.77,9.38-10,32-8.58,21-6.52,19.38-12,31-8.88,18.83-12.57,19.53-15,31-2.15,10.14-1.11,18.28,0,27,1.37,10.76,2.38,17.89,8,23,2.21,2,5.84,3.37,13,6,15.31,5.62,17.91,4.09,21,8,3.38,4.28,3.43,10.09,3.5,19.2,0,1.69-.06,2.28-.5,2.8-2.95,3.43-15.16-4.86-34-13-26.23-11.34-31.15-7.64-40-17-4.1-4.33-6.9-9.2-14-12a29.34,29.34,0,0,0-17-1c-9.51,2.13-15.32,8.18-19,12,0,0-3.23,3.36-14,21h0" transform="translate(-47.07 -6.05)" fill-opacity="null" stroke-opacity="null" stroke="#000" fill="none" />
      </g>
    </svg>

    <!-- <div class="plane" [ngClass]="{'to-1': plane.position == 1, 'to-2': plane.position == 2, 'to-3': plane.position == 3, 'to-4': plane.position == 4}"></div> -->

    <audio id="introductionAudio" (ended)="playBgAudio()">
      <source src="assets/sounds/country.wav" type="audio/wav">
    </audio>
    <audio id="bgAudio" (ended)="playIntroductionAudio()">
      <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
    </audio>

    <img class="frame-bg" src="assets/images/zones/3/zone3-bg.jpg">
  </div>
</div>

<img class="frame-title" src="assets/images/zones/1/title.png">

<div class="footer">
  <ul class="zone-menu">
    <li>
      <a class="menu-item" [routerLink]="[ '/game/zone1' ]" routerLinkActive="active">1</a>
    </li>
    <li>
      @if (!haveAccess('1-2')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-2')) {
        <a class="menu-item" [routerLink]="[ '/game/zone2' ]" routerLinkActive="active">2</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-3')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-3')) {
        <a class="menu-item" [routerLink]="[ '/game/zone3' ]" routerLinkActive="active">3</a>
      }
    </li>
    <li>
      @if (!haveAccess('1-4')) {
        <span class="lock"></span>
      }
      @if (haveAccess('1-4')) {
        <a class="menu-item" [routerLink]="[ '/game/zone4' ]" routerLinkActive="active">4</a>
      }
    </li>
  </ul>
  <img class="footer-bg" src="assets/images/zones/3/footer3.png">
</div>

<audio id="continentHover">
  <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
</audio>
<audio id="continentClick">
  <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
</audio>
